import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    discount: '{discountPrice} instead of {basePrice}',
    footer: {
      details:
        'This offer includes {trialPeriod} months of {planName}. Then, you will be charged **{pricePerMonth} / month excl. tax**, by automatic withdrawal on your Shine account or on your card if your balance is insufficient. You can cancel or modify your subscription at any time.',
      label: 'No hidden fees. No bad surprises.',
    },
    includingVat: 'including tax',
    title: 'Payment',
  },
  fr: {
    discount: '{discountPrice} au lieu de {basePrice}',
    footer: {
      details:
        'Cette offre inclut {trialPeriod} mois de {planName}. Puis, vous serez facturé **{pricePerMonth} / mois HT**, par prélèvement automatique sur votre compte Shine ou sur votre carte si votre solde est insuffisant. Vous pouvez annuler ou modifier votre abonnement à tout moment.',
      label: 'Sans frais cachés. Sans mauvaise surprise.',
    },
    includingVat: 'TTC',
    title: 'Paiement',
  },
} as const);

export default locales;
